import { DirectiveBinding } from "vue";

export default {
  beforeMount(el: HTMLElement, binding: DirectiveBinding) {
    const isHtml = (str: string) => /<\/?[a-z][\s\S]*>/i.test(str);

    if (isHtml(binding.value)) {
      el.innerHTML = binding.value;
    } else {
      el.textContent = binding.value;
    }
  },
  updated(el: HTMLElement, binding: DirectiveBinding) {
    const isHtml = (str: string) => /<\/?[a-z][\s\S]*>/i.test(str);

    if (isHtml(binding.value)) {
      el.innerHTML = binding.value;
    } else {
      el.textContent = binding.value;
    }
  },
};
